// removed by extract-text-webpack-plugin
module.exports = {"filtersContainer":"_3Vfa4","filterTitle":"_3FCzg"};


//////////////////
// WEBPACK FOOTER
// ./src/views/v2/search/components/filter/styles.module.css
// module id = 232
// module chunks = 0